"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Login = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _reactRouterRedux = require("react-router-redux");

var _auth = require("../../redux/modules/auth");

var _reduxForm = require("redux-form");

var _loginValidator = require("./loginValidator");

var _loginValidator2 = _interopRequireDefault(_loginValidator);

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _LoginForm = require("../../components/login/LoginForm");

var _LoginForm2 = _interopRequireDefault(_LoginForm);

var _UserUtil = require("../../utils/UserUtil");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Login = exports.Login = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Login, _Component);

  function Login() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Login);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Login.__proto__ || (0, _getPrototypeOf2.default)(Login)).call.apply(_ref, [this].concat(args))), _this), _this.submit = function (values) {
      _this.props.login(values);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Login, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.auth.user) {
        this.props.pushRoute("/");
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _props = this.props,
          user = _props.auth.user,
          pushRoute = _props.pushRoute;
      // console.info('Login.js: user', user);

      if (user && !(0, _UserUtil.isPaidUser)(user)) {
        // pushRoute('/maksullinen-profiili');
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "col col-xs-12" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Kirjaudu" }),
        _react2.default.createElement(
          "h1",
          { className: "h3" },
          "Kirjaudu"
        ),
        _react2.default.createElement(_LoginForm2.default, {
          fields: this.props.fields,
          handleSubmit: this.props.handleSubmit,
          onSubmit: this.submit,
          auth: this.props.auth
        })
      );
    }
  }]);
  return Login;
}(_react.Component), _class.propTypes = {
  fields: _react.PropTypes.object.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired,
  login: _react.PropTypes.func.isRequired,
  pushRoute: _react.PropTypes.func.isRequired,
  auth: _react.PropTypes.object.isRequired
}, _temp2);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    auth: state.auth
  };
}, {
  login: _auth.login,
  pushRoute: _reactRouterRedux.push
})((0, _reduxForm.reduxForm)({
  form: "login",
  fields: ["email", "password"],
  validate: _loginValidator2.default
})(Login));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Login/Login.js
 ** module id = 1219
 ** module chunks = 0
 **/